'use client';

import React from 'react';
import styles from './LoadingSpinner.module.scss';

interface LoadingSpinnerProps {
  isLoading?: boolean;
  loadingText?: string;
  ariaLabel?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ isLoading = true, loadingText = 'Loading...', ariaLabel = 'Content is loading, please wait' }) => {
  if (isLoading) {
    return (
      <div className={styles.loadingContainer} data-testid="loading-container" role="status" aria-live="polite" aria-busy="true" aria-label={ariaLabel}>
        <div className={styles.loadingSpinner}>
          <div className={styles.spinner} aria-hidden="true"></div>
          <p className={styles.loadingText} aria-live="polite">
            {loadingText}
          </p>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default LoadingSpinner;
